<button #ref (click)="button.action($event)" [class]="classes">{{ button.label }}</button>



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/button.widget.html